import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import dialog from "../../components/dialog/Dialog";
import EligibilityAlertsModal from "./EligibilityAlertsModal";

export default function EligibilityAlertIcon({patientId, hasUnresolvedAlerts, onAlertResolved, readOnly}) {
    if (!patientId) {
        return null;
    }

    const openAlertsDialog = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dialog({
            className: "dialog-lg",
            title: "Eligibility Alerts",
            component: <EligibilityAlertsModal patientId={patientId} onAlertResolved={onAlertResolved}/>
        });
    };

    return (
        <FontAwesomeIcon
            icon={["fas", "exclamation-triangle"]}
            title={hasUnresolvedAlerts ? "Patient has unresolved eligibility alerts" : "No unresolved eligibility alerts"}
            onClick={readOnly ? undefined : openAlertsDialog}
            style={{
                color: hasUnresolvedAlerts ? "#dc3545" : "#28a745",
                marginLeft: 6,
                marginRight: 6,
                cursor: readOnly ? "default" : "pointer"
            }}
        />
    );
}
